module.exports = __webpack_public_path__ + "img/login@2.c166bc93.jpg";